import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../core/services/auth.service';
import { FileService } from '../../../core/services/file.service';
import { DirectoryStateService } from '../../../core/services/state/directory-state.service';
import { MenuitemComponent } from '../menuitem/menuitem.component';

@Component({
    selector: 'app-menu',
    standalone: true,
    imports: [CommonModule, ButtonModule, MenuitemComponent],
    templateUrl: './menu.component.html'
})
export class MenuComponent implements OnInit {

    @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
    @ViewChild('directoryInput') directoryInput!: ElementRef<HTMLInputElement>;

    model: MenuItem[] = [];

    uploading: boolean = false;

    uploadProgress: {
        name: string;
        progress: number;
        error?: boolean;
        errorMessage?: string;
    }[] = [];

    constructor(public router: Router,
        private readonly authService: AuthService) {
    }

    ngOnInit() {
        const userRoles = this.authService.getRoles();

        const rawMenu: MenuItem[] = [
            {
                label: 'Início',
                roles: ['ADMIN'],
                items: [
                    { label: 'Painel', icon: 'pi pi-fw pi-home', routerLink: ['/'], disabled: true }
                ],
                visible: false
            },
            {
                label: 'Meus Arquivos',
                icon: 'pi pi-folder',
                roles: ['ADMIN', 'USER'],
                items: [
                    { label: 'Diretórios', icon: 'pi pi-folder-open', routerLink: '/default/shareds' },
                    { label: 'Scanner', icon: 'pi pi-inbox', routerLink: '/default/scanner' },
                    { label: 'Favoritos', icon: 'pi pi-star', routerLink: '/files/favorites', disabled: true },
                    { label: 'Lixeira', icon: 'pi pi-trash', routerLink: '/default/recycle-bin' }
                ]
            },
            {
                label: 'Ferramentas',
                icon: 'pi pi-wrench',
                roles: ['ADMIN', 'USER'],
                items: [
                    { label: 'Assinatura Digital', icon: 'pi pi-pencil', routerLink: '/signature', disabled: true },
                    { label: 'OCR e Leitura', icon: 'pi pi-eye', routerLink: '/ocr', disabled: true }
                ],
                visible: false
            },
            {
                label: 'Administração',
                icon: 'pi pi-cog',
                roles: ['ADMIN'],
                items: [
                    { label: 'Recursos Compartilhados', icon: 'pi pi-share-alt', routerLink: '/admin/directories' },
                    { label: 'Acessos FTP', icon: 'pi pi-cloud', routerLink: '/admin/ftp-access' },
                    {
                        label: 'Usuários e Acessos',
                        icon: 'pi pi-sign-in',
                        items: [
                            { label: 'Grupos', icon: 'pi pi-briefcase', routerLink: '/admin/groups' },
                            { label: 'Usuários', icon: 'pi pi-users', routerLink: '/admin/users' }
                        ]
                    },
                    { label: 'Notificações', icon: 'pi pi-bell', routerLink: '/notifications', disabled: true, visible: false }
                ]
            }
        ];

        // const rawMenu: MenuItem[] = [
        //     {
        //         label: 'Home',
        //         roles: ['admin'],
        //         items: [{ label: 'Dashboard', icon: 'pi pi-fw pi-home', routerLink: ['/'] }]
        //     },
        //     {
        //         label: 'UI Components',
        //         roles: ['admin', 'user'],
        //         items: [
        //             { label: 'Form Layout', icon: 'pi pi-fw pi-id-card', routerLink: ['/uikit/formlayout'] },
        //             { label: 'Input', icon: 'pi pi-fw pi-check-square', routerLink: ['/uikit/input'] },
        //             {
        //                 label: 'Button',
        //                 icon: 'pi pi-fw pi-mobile',
        //                 class: 'rotated-icon',
        //                 routerLink: ['/uikit/button']
        //             },
        //             { label: 'Table', icon: 'pi pi-fw pi-table', routerLink: ['/uikit/table'] },
        //             { label: 'List', icon: 'pi pi-fw pi-list', routerLink: ['/uikit/list'] },
        //             { label: 'Tree', icon: 'pi pi-fw pi-share-alt', routerLink: ['/uikit/tree'] },
        //             { label: 'Panel', icon: 'pi pi-fw pi-tablet', routerLink: ['/uikit/panel'] },
        //             { label: 'Overlay', icon: 'pi pi-fw pi-clone', routerLink: ['/uikit/overlay'] },
        //             { label: 'Media', icon: 'pi pi-fw pi-image', routerLink: ['/uikit/media'] },
        //             { label: 'Menu', icon: 'pi pi-fw pi-bars', routerLink: ['/uikit/menu'] },
        //             { label: 'Message', icon: 'pi pi-fw pi-comment', routerLink: ['/uikit/message'] },
        //             { label: 'IFile', icon: 'pi pi-fw pi-file', routerLink: ['/uikit/file'] },
        //             { label: 'Chart', icon: 'pi pi-fw pi-chart-bar', routerLink: ['/uikit/charts'] },
        //             { label: 'Timeline', icon: 'pi pi-fw pi-calendar', routerLink: ['/uikit/timeline'] },
        //             { label: 'Misc', icon: 'pi pi-fw pi-circle', routerLink: ['/uikit/misc'] }
        //         ]
        //     },
        //     {
        //         label: 'Pages',
        //         icon: 'pi pi-fw pi-briefcase',
        //         roles: ['admin', 'user'],
        //         routerLink: ['/pages'],
        //         items: [
        //             {
        //                 label: 'Landing',
        //                 icon: 'pi pi-fw pi-globe',
        //                 routerLink: ['/landing']
        //             },
        //             {
        //                 label: 'Auth',
        //                 icon: 'pi pi-fw pi-user',
        //                 items: [
        //                     {
        //                         label: 'Login',
        //                         icon: 'pi pi-fw pi-sign-in',
        //                         routerLink: ['/auth/login']
        //                     },
        //                     {
        //                         label: 'Error',
        //                         icon: 'pi pi-fw pi-times-circle',
        //                         routerLink: ['/auth/error']
        //                     },
        //                     {
        //                         label: 'Access Denied',
        //                         icon: 'pi pi-fw pi-lock',
        //                         routerLink: ['/auth/access']
        //                     }
        //                 ]
        //             },
        //             {
        //                 label: 'Crud',
        //                 icon: 'pi pi-fw pi-pencil',
        //                 routerLink: ['/pages/crud']
        //             },
        //             {
        //                 label: 'Not Found',
        //                 icon: 'pi pi-fw pi-exclamation-circle',
        //                 routerLink: ['/pages/notfound']
        //             },
        //             {
        //                 label: 'Empty',
        //                 icon: 'pi pi-fw pi-circle-off',
        //                 routerLink: ['/pages/empty']
        //             }
        //         ]
        //     },
        //     {
        //         label: 'Hierarchy',
        //         roles: ['admin', 'user'],
        //         items: [
        //             {
        //                 label: 'Submenu 1',
        //                 icon: 'pi pi-fw pi-bookmark',
        //                 items: [
        //                     {
        //                         label: 'Submenu 1.1',
        //                         icon: 'pi pi-fw pi-bookmark',
        //                         items: [
        //                             { label: 'Submenu 1.1.1', icon: 'pi pi-fw pi-bookmark' },
        //                             { label: 'Submenu 1.1.2', icon: 'pi pi-fw pi-bookmark' },
        //                             { label: 'Submenu 1.1.3', icon: 'pi pi-fw pi-bookmark' }
        //                         ]
        //                     },
        //                     {
        //                         label: 'Submenu 1.2',
        //                         icon: 'pi pi-fw pi-bookmark',
        //                         items: [{ label: 'Submenu 1.2.1', icon: 'pi pi-fw pi-bookmark' }]
        //                     }
        //                 ]
        //             },
        //             {
        //                 label: 'Submenu 2',
        //                 icon: 'pi pi-fw pi-bookmark',
        //                 items: [
        //                     {
        //                         label: 'Submenu 2.1',
        //                         icon: 'pi pi-fw pi-bookmark',
        //                         items: [
        //                             { label: 'Submenu 2.1.1', icon: 'pi pi-fw pi-bookmark' },
        //                             { label: 'Submenu 2.1.2', icon: 'pi pi-fw pi-bookmark' }
        //                         ]
        //                     },
        //                     {
        //                         label: 'Submenu 2.2',
        //                         icon: 'pi pi-fw pi-bookmark',
        //                         items: [{ label: 'Submenu 2.2.1', icon: 'pi pi-fw pi-bookmark' }]
        //                     }
        //                 ]
        //             }
        //         ]
        //     },
        //     {
        //         label: 'Get Started',
        //         roles: ['admin', 'user'],
        //         items: [
        //             {
        //                 label: 'Documentation',
        //                 icon: 'pi pi-fw pi-book',
        //                 routerLink: ['/documentation']
        //             },
        //             {
        //                 label: 'View Source',
        //                 icon: 'pi pi-fw pi-github',
        //                 url: 'https://github.com/primefaces/mydocs',
        //                 target: '_blank'
        //             }
        //         ]
        //     }
        // ];

        this.model = this.filterMenuByRoles(rawMenu, userRoles);
    }

    navigateToPlans() {
        this.router.navigate(['/default/upgrade-plan']);
    }

    filterMenuByRoles(menu: MenuItem[], roles: string[]): MenuItem[] {
        return menu
            .filter(item => !item['roles'] || item['roles'].some((role: string) => roles.includes(role)))
            .map(item => ({
                ...item,
                items: item.items ? this.filterMenuByRoles(item.items, roles) : undefined
            }));
    }

    onDialogClose() {
        this.uploading = false;
        this.uploadProgress = [];
        if (this.fileInput) {
            this.fileInput.nativeElement.value = ''; // reseta input
        }
    }
}
